<template>
    <gofix-card fullContent class="mb-0 pt-20">
        <b-col md="12">
            <b-row align-v="center">
                <b-col md="3">
                    <b-row>
                        <b-col md="6">
                            <gofix-form-dropdown
                                class="mb-0"
                                label="Month"
                                :clearable="false"
                                :filterable="false"  
                                fullContent
                                :searchable="false"
                                :options="months"
                                vLabel="text"
                                :reduce="option => option.value"
                                v-model="month">
                            </gofix-form-dropdown>
                        </b-col>
                        <b-col md="6">
                            <gofix-form-dropdown
                                class="mb-0"
                                label="Year"
                                :clearable="false"
                                :filterable="false" 
                                :searchable="false"
                                :options="years"
                                v-model="year">
                            </gofix-form-dropdown>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col md="4">
                    <b-row>
                        <b-col md="7">
                            <gofix-form-dropdown
                                class="mb-0"
                                v-bind:class="{'run-loading small-loading': loading}"
                                label="Supplier Contract"
                                vLabel="contract_title"
                                @search="searchSupplierContract"
                                :filterable="false"
                                v-model="supplier_contract"
                                :options="supplier_contracts">
                            </gofix-form-dropdown>
                        </b-col>
                        <b-col md="5">
                            <gofix-form-dropdown 
                                class="mb-0"
                                label="Property Type" 
                                :filterable="false" 
                                :options="property_types" 
                                v-model="property_type"
                                :clearable="false"
                                required 
                                show-icon-required>
                            </gofix-form-dropdown>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col md="5">
                    <b-row align-v="center">
                        <b-col md="8">
                            <gofix-form-dropdown
                                class="mb-0"
                                v-bind:class="{'run-loading small-loading': loading}"
                                label="Division" 
                                :filterable="false" 
                                :options="locations" 
                                v-model="location" 
                                @search="searchLocation" 
                                vLabel="name"
                                show-icon-required>
                                <template slot="gofixInput:dropdown:selected-option" slot-scope="option">
                                    <span class="text-hidden-one-row">{{ option.location_path || '-' }}</span>
                                </template>
                                <template slot="gofixInput:dropdown:option" slot-scope="option">
                                    <span v-b-tooltip.hover.top :title="option.location_path" v-html="$options.filters.highlightNode(option.location_path, key_search_property)"></span>
                                </template>
                            </gofix-form-dropdown>
                        </b-col>
                        <b-col md="4" class="text-center">
                            <gofix-button class="mb-2 mx-2 width-131" label="Export PDF" @click="exportReport()" :disabled="activeExportBtn == false"></gofix-button>
                            <gofix-button class="mb-2 mx-2 width-131" label="Export Excel" @click="exportExcel(false)" :disabled="activeExportBtn == false"></gofix-button>
                            <gofix-button class="width-131" label="Export Excel(All)" @click="exportExcel(true)"></gofix-button>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </b-col>
        <hr/>
        <gofix-table :settings="tableConfig"
            :table-items="tableItems"
            @load-items="getTableData"
            ref="gofixTable">
            <template slot="gofix_table:id" slot-scope="row">
                {{ row.index + 1 }}
            </template>
            <template slot="gofix_table:property" slot-scope="row">
                {{ row.item.property && row.item.property.name ? row.item.property.name : '--' }}
            </template>
            <template slot="gofix_table:user" slot-scope="row">
                {{ row.item.user && row.item.user.name ? row.item.user.name : '--' }} {{ row.item.user && row.item.user.email ? '- ' + row.item.user.email : '' }}
            </template>
            <template slot="gofix_table:ld_id" slot-scope="row">
                {{ row.item.ld_id ? row.item.ld_id : '--' }} 
            </template>
            <template slot="gofix_table:ld_date" slot-scope="row">
                {{ row.item.ld_date | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY") }}
            </template>
            <template slot="gofix_table:total" slot-scope="row">
                {{ row.item.total | formatMoney(0) }}
            </template>
        </gofix-table>
    </gofix-card>
</template>
<script>
import moment from 'moment';
export default {
    name: 'report-rates-of-deduction',
    props: {
        propertyType: {
            type: String,
            default: '',
        },
        contract: {
            type: Object,
            default: () => null,
        }
    },
    data() {
        return {
            tableConfig:{
                name: 'table-report-rates-of-deduction',
                controls:{
                    create: false,
                    update: false,
                    delete: false,
                    tableImport: false,
                    tableExport: false,
                    tableColumnSettings: false,
                    reload: false,
                    tablePagination: false,
                    tableFilter: false
                },
                filter: { },
                page: 1,
                limit: 100,
                sortColumn: "id",
                sortDirection: "asc",
                fields: [
                    {
                        key: 'id',
                        label: 'S/N',
                        isActive: 1,
                        isFilter: false,
                        thStyle: "width: 100px",
                        sorting: false,
                        thClass: 'text-center',
                        tdClass: 'text-center'
                    },
                    {
                        key: 'user',
                        label: 'PO in Charge',
                        isActive: 1,
                        isFilter: false,
                        thStyle: 'width: 200px',
                        sorting: false,
                        thClass: 'text-left',
                        tdClass: 'text-left'
                    },
                    {
                        key: 'ld_id',
                        label: 'LD ID',
                        isActive: 1,
                        isFilter: false,
                        thStyle: 'width: 200px',
                        sorting: false,
                        thClass: 'text-left',
                        tdClass: 'text-left'
                    },
                    {
                        key: 'ld_date',
                        label: 'LD Date',
                        isActive: 1,
                        isFilter: false,
                        thStyle: 'width: 200px',
                        sorting: false,
                        thClass: 'text-left',
                        tdClass: 'text-left'
                    },
                    {
                        key: 'property',
                        label: 'Address',
                        isActive: 1,
                        isFilter: false,
                        thStyle: 'width: 300px',
                        sorting: false,
                        thClass: 'text-left',
                        tdClass: 'text-left'
                    },
                    {
                        key: 'remarks',
                        label: 'Remarks',
                        isActive: 1,
                        isFilter: false,
                        thStyle: 'width: 200px',
                        sorting: false,
                        thClass: 'text-left',
                        tdClass: 'text-left'
                    },
                    {
                        key: 'description',
                        label: 'Description',
                        isActive: 1,
                        isFilter: false,
                        thStyle: 'width: 200px',
                        sorting: false,
                        thClass: 'text-center',
                        tdClass: 'text-center'
                    },
                    {
                        key: 'unit',
                        label: 'Unit',
                        isActive: 1,
                        isFilter: false,
                        thStyle: 'width: 200px',
                        sorting: false,
                        thClass: 'text-center',
                        tdClass: 'text-center'
                    },
                    {
                        key: 'quantity',
                        label: 'Qty',
                        isActive: 1,
                        isFilter: false,
                        thStyle: 'width: 100px',
                        sorting: false,
                        thClass: 'text-center',
                        tdClass: 'text-center'
                    },
                    {
                        key: 'total',
                        label: 'Total',
                        isActive: 1,
                        isFilter: false,
                        thStyle: 'width: 150px',
                        sorting: false,
                        thClass: 'text-center',
                        tdClass: 'text-center'
                    },
                    {
                        key: 'auto',
                        label: '',
                        isActive: 1,
                        isFilter: false,
                        sorting: false,
                        thClass: 'text-center',
                        tdClass: 'text-center'
                    },
                ]
            },
            tableItems: [],
            supplier_contracts: [],
            supplier_contract: '',
            locations: [],
            location: '',
            property_types: ['Residential', 'Hawker Centre'],
            property_type: 'Residential',
            years: [],
            year: '',
            months: [],
            month: '',
            timer: {
                location: null,
                save: null
            },
            activeExportBtn: false,
            tableFooter: {
                deduction: 0,
                percent_payment_to_contractor: 0,
                payment_to_contractor: 0,
                total_actual_score: 0,
                total_weight: 0
            }
        }
    },
    watch: {
        ClientContractID: function(val) {
            this.getSupplierContract()
        },
        "supplier_contract": function(val) {
            this.location = null
            this.searchLocation('', () => {})
        },
        "location": function(val) {
            this.$refs.gofixTable.reloadTableItems();
        },
        "property_type": function(val) {
            this.location = null
            this.searchLocation('', () => {})
            this.$refs.gofixTable.reloadTableItems();
        },
        "month": function(val) {
            this.$refs.gofixTable.reloadTableItems();
        },
        "year": function(val) {
            this.$refs.gofixTable.reloadTableItems();
        },
    },
    created() {
        this.getInitData()
        this.getSupplierContract()
    },
    filters: {
        highlightNode(val, option_selected) {
            if(option_selected) {
                if(option_selected.name) {
                    val = val.replace(option_selected.name, `<span class="d-inline font-weight-bold">${option_selected.name}</span>`);
                } else {
                    let regex = new RegExp(option_selected, "i");
                    let index = val.search(regex);
                    let substr = val.substr(index, option_selected.length);
                    val = val.replace(regex, `<span class="d-inline font-weight-bold">${substr}</span>`);
                }
            }

            return val;
        }
    },
    methods: {
        async getTableData(callback) {
            const { tableRequest , resolve,reject } = await callback();
            this.tableFooter.deduction = 0;
            this.tableFooter.percent_payment_to_contractor = 0;
            this.tableFooter.payment_to_contractor = 0;
            this.tableFooter.total_actual_score = 0;
            this.tableFooter.total_weight = 0;
            
            if ( !this.supplier_contract || !this.location ) {
                this.activeExportBtn = false
                const response = {
                    items: [],
                    total: 0
                }
                resolve(response);
                this.tableItems = response.items;
                this.tableConfig.total = response.total;
                return;
            }

            tableRequest.month = this.month
            tableRequest.year = this.year
            tableRequest.contract_id = this.supplier_contract.id
            tableRequest.property_id = this.location.location_id
            tableRequest.property_type = this.property_type
            tableRequest.type = 'rates of deduction'

            await this.$store.dispatch("PAConservancyController/getPAReport", tableRequest)
            .then(response => {
                this.tableItems = response.items;
                this.tableConfig.total = response.total;
                this.tableFooter.deduction = response.deduction || 0;
                this.tableFooter.percent_payment_to_contractor = response.percent_payment_to_contractor || 0;
                this.tableFooter.payment_to_contractor = response.payment_to_contractor || 0;
                this.tableFooter.total_actual_score = response.total_actual_score || 0;
                this.tableFooter.total_weight = response.total_weight || 0;
                this.tableFooter.less_rates_of_deduction = response.less_rates_of_deduction || 0;
                resolve(response);

                if(this.tableConfig.total != 0){
                    this.activeExportBtn = true
                }else{
                    this.activeExportBtn = false
                }
            })
            .catch(err => { })
        },
        getInitData(){
            this.loadingData = true;
            var iYear = parseInt(moment().format('YYYY'));
            if(this.Year) this.year = this.Year;
            else this.year = iYear;
            
            for(var i=0;i<15;i++){
                this.years.push(iYear);
                iYear--;
            }
            this.month = moment().format('MM');
            this.populateMonthHeaders();
        },
        populateMonthHeaders(){
            var mTime = moment(this.year+"-"+"January"+"-"+"01","YYYY-MMMM-DD");
            var iMonth = 0;
            var iMonths = [];
            while(iMonth<12){
                var dTime = mTime.clone();
                dTime.add(iMonth,'month');
                iMonths.push({'text' : dTime.format('MMMM'), 'value' : dTime.format('MM')});
                iMonth++;
            }
            this.months = iMonths;
        },
        async getSupplierContract(search = null) {
            this.loading = true
            let tableRequest = {
                filter: {
                    contract_title: { type: "text", value: search, function: "ilike", with: [] },
                    contract_id: this.ClientContractID && this.ClientContractID.id ? this.ClientContractID.id : ""
                },
                limit: 100,
                page: 1,
                isCMS: 1,
                useDatabaseView: true,
                sortColumn: "contract_title",
                sortDirection: "ASC"
            }
            await this.$store.dispatch("ContractController/getListSContracts", tableRequest)
            .then(response => {
                this.tableItems = [];
                this.tableConfig.total = 0;

                this.supplier_contracts = response.data.data.contracts
                
                if(search === null) {
                    this.supplier_contract = null
                    if(response.data.data.contracts[0]){
                        this.supplier_contract = response.data.data.contracts[0]
                    }
                }
                
                this.loading = false
            })
            .catch(err => {
                this.loading = false
            })
        },
        searchSupplierContract(search, loading){
            loading(true);
            this.supplier_contracts = []
            if(this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
            this.timer = setTimeout(async () => {
                try {
                    await this.getSupplierContract(search);
                    await loading(false);
                } catch (err) {
                    loading(false);
                }
            }, 500);
        },
        searchLocation(search, loading) {
            this.loading = true
            this.locations = []
            if (this.timer.location) {
                clearTimeout(this.timer.location);
                this.timer.location = null;
            }
            this.timer.location = setTimeout(() => {
                this.key_search_property = search;
                const property_root_id = this.supplier_contract ? this.supplier_contract.property_root_id : null
                const contract_id = this.supplier_contract ? this.supplier_contract.id : null

                this.$store.dispatch('PerformanceAssesmentSettingsController/getItems', {
                    keyword: search,
                    property_root_id: property_root_id,
                    type_setting: 'pa_contract_sum_setting',
                    filter: {
                        contract_id: contract_id,
                        property_type: this.property_type,
                        location_name: ''
                    },
                    sortColumn: 'location_name',
                    sortDirection: 'asc',
                })
                .then(response => {
                    this.locations = response.items
                    this.loading = false
                })
                .catch(err => {
                    this.loading = false
                })
            }, 500);
        },
        async dataPAReport() {
            if ( !this.supplier_contract ) {
                return false;
            }
            if ( !this.location ) {
                return false;
            }

            let getParam = {
                month: this.month,
                year: this.year,
                contract_id: this.supplier_contract.id,
                property_id: this.location.location_id,
                property_type: this.property_type,
                type: 'rates of deduction'
            };

            await this.$store.dispatch("PAConservancyController/getPAReport", getParam)
            .then(response => {
                this.tableItems = response.items
            })
            .catch(err => { })
        },
        async exportReport() {
            let getParam = {
                month: this.month,
                year: this.year,
                contract_id: this.supplier_contract.id,
                property_id: this.location.location_id,
                property_type: this.property_type,
                type: 'rates of deduction',
                is_download_pdf: true,
            };

            await this.$store.dispatch("PAConservancyController/exportPAReport", getParam)
            .then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'rates of deduction-' + this.month + '-' + this.year + '.pdf');
                document.body.appendChild(link);
                link.click();
            })
            .catch(err => { })
        },
        async exportExcel(is_export_all = false) {
            let contract_id = null;
            if(is_export_all) {
                if(!this.ClientContractID || !this.ClientContractID.id) return this.$alertNotification("Please select a contract", "danger");
                if(!this.month) return this.$alertNotification("Month is required", "danger");
                if(!this.year) return this.$alertNotification("Year is required", "danger");
                contract_id = this.ClientContractID.id
            } else {
                contract_id = this.supplier_contract.id;
            }
            
            let getNewParam = {
                month: this.month,
                year: this.year,
                contract_id: contract_id,
                property_type: this.property_type,
                property_id: this.location && this.location.location_id ? this.location.location_id : null,
                is_export_all: is_export_all
            };

            await this.$store.dispatch("PAConservancyController/exportRatesOfDeductionExcel", getNewParam)
            .then(response => {
                let nameFile = 'Rates_Of_Deduction.xlsx';
                if(is_export_all == true) nameFile = 'Rates_Of_Deduction.zip';
                if(response.headers["content-disposition"]) {
                  let arrTemp = response.headers["content-disposition"].split("filename=");
                  if(arrTemp[1]) {
                    nameFile = arrTemp[1].replaceAll('"', "");
                  }
                }

                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', nameFile);
                document.body.appendChild(link);
                link.click();
            })
            .catch(err => {
                if(err.response && err.response.status && err.response.status == 400) {
                    return this.$alertNotification("Data is empty, please try again.", "danger");
                }
            })
        },
    }
}
</script>